module.exports = __webpack_public_path__ + "img/shape-metal_aa@2x.476c8dd1.png";